import { useQuery } from '@tanstack/react-query';
import { settingsService } from '../services/api';

export function useAllowedClientCreateRoles() {
  return useQuery({
    queryKey: ['client-access-roles'],
    queryFn: async () => {
      const res = await settingsService.getClientCreateAllowedRoles();
      return res.data?.roles || ['CEO'];
    },
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchOnMount: 'always',
  });
}